import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { ContentLoader, Button, Text, useModalControl } from '@frontend/design-system';
import { UseExistingLayoutModal } from './modals/use-existing-layout.modal';
import { useLineKeyContext } from './store/line-key-provider';

export const LineKeyFooter = ({
  isLoading,
  onSaveClick,
  onCancelClick,
}: {
  isLoading?: boolean;
  onSaveClick: () => void;
  onCancelClick: () => void;
}) => {
  const { t } = useTranslation('phone', { keyPrefix: 'line-keys' });
  const { device } = useLineKeyContext();
  const { modalProps: copyLayoutModalProps, triggerProps: copyLayoutTriggerProps } = useModalControl();

  return (
    <>
      <ContentLoader show={isLoading} />
      <footer css={footerStyles}>
        <Button label={t('Save')} onClick={onSaveClick}>
          {t('Save')}
        </Button>
        <Button label={t('Cancel')} variant='secondary' onClick={onCancelClick}>
          {t('Cancel')}
        </Button>
        <Button
          label={t('Use an Existing Line Key Layout')}
          variant='tertiary'
          trackingId='duplicate-from-use-existing-layout'
          onClick={copyLayoutTriggerProps.onClick}
        >
          <Text color='primary' weight='bold'>
            {t('Use an Existing Line Key Layout')}
          </Text>
        </Button>
      </footer>
      <UseExistingLayoutModal device={device} {...copyLayoutModalProps} />
    </>
  );
};

const footerStyles = css`
  display: flex;
  gap: ${theme.spacing(2)};
  align-items: center;
  padding: ${theme.spacing(3)};
  border-top: 1px solid ${theme.colors.neutral20};
  background: ${theme.colors.white};
  width: 100%;
  height: ${theme.spacing(10)};

  button {
    width: fit-content;
  }

  @media (max-width: 480px) {
    height: ${theme.spacing(14)};
    flex-flow: wrap;

    button {
      width: 150px;
    }
  }
`;
